import React from 'react';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { Header } from 'login/header';
import DeltaSnp from 'main/DeltaSnp';

function App({ signOut, user }) {
  return <DeltaSnp signOut={signOut} user={user} />;
}

export default withAuthenticator(App, {
  components: {
    SignIn: {
      Header: Header,
    },
  },
  loginMechanisms: ['username'],
  hideSignUp: true,
});
